module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hant_5-9c6c3afd5ce2bbc52736865391f58d96.jpg";